import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { ListSurveys } from "Features/Survey";

function VolumeList () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle
                title={t("pages.volumes")}
            />
            <ListSurveys surveyRef="volume" />
        </Container>
    );
}

export default VolumeList;